import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/toolbox-header-image-lg-desktop.jpg")